import React, { useState } from "react";

const defaultState = {
  token: null,
  modalOpen: false,
  setModalOpen: () => {},
  externalUrl: null,
  setExternalUrl: () => {},
  modalType: null,
  setModalType: () => {},
};

const AppContext = React.createContext(defaultState);

const AppProvider = ({ children }) => {
  const [token, setToken] = useState(defaultState.token);
  const [modalOpen, setModalOpen] = useState(defaultState.modalOpen);
  const [externalUrl, setExternalUrl] = useState(defaultState.externalUrl);
  const [modalType, setModalType] = useState(defaultState.modalType);
  const store = {
    token,
    setToken,
    modalOpen,
    setModalOpen,
    externalUrl,
    setExternalUrl,
    modalType,
    setModalType,
  };
  return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};

export default AppContext;

export { AppProvider };
